<template>
  <div class="module-wrapper">
    <div class="module-header animated fadeInDown">
      <h2>Factories</h2>
      <button @click="addFactory" class="btn btn-gradient-factory">
        <i class="fas fa-plus"></i> Add Factory
      </button>
    </div>

    <div v-if="loading" class="spinner-container">
      <i class="fas fa-spinner fa-spin fa-2x"></i> Loading Factories...
    </div>

    <div v-else>
      <table v-if="factories.length" class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Name</th>
            <th>Location</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="factory in factories" :key="factory.id">
            <td>{{ factory.name }}</td>
            <td>{{ factory.location }}</td>
            <td>
              <span :class="['badge', factory.status==='active'?'active':'inactive']">{{ factory.status }}</span>
            </td>
            <td>
              <button @click="editFactory(factory)" class="btn btn-sm btn-primary">Edit</button>
              <button @click="deleteFactory(factory.id)" class="btn btn-sm btn-danger">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>

      <p v-else>No factories yet.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'FactoriesComponent',
  computed: { ...mapState('factories', ['factories','loading']) },
  methods: {
    addFactory(){ this.$router.push({name:'AddFactory'}); },
    editFactory(factory){ console.log('Edit', factory); },
    deleteFactory(id){ if(confirm('Delete this factory?')) this.$store.dispatch('factories/deleteFactory', id); }
  },
  mounted(){ this.$store.dispatch('factories/fetchFactories'); }
};
</script>

<style scoped>
.btn-gradient-factory { background: linear-gradient(135deg,#f7971e,#ffd200); color:#fff; border:none; padding:8px 15px; border-radius:6px; transition:all 0.3s;}
.btn-gradient-factory:hover{ transform: scale(1.05);}
</style>
